import { Injectable } from "@angular/core";
import { NavController} from '@ionic/angular';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {

  constructor(
    private nav: NavController,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    var data = localStorage.getItem("hectoron_admin_data");
    console.log(data);
    if (data == undefined || data == null) {
      // window.location.href = './login';
      this.nav.navigateForward('login');
      
      return false
    }
    else{
      return true;
    }
  }
}
